import { render, staticRenderFns } from "./story-row.vue?vue&type=template&id=4c9553ee&scoped=true&"
import script from "./story-row.vue?vue&type=script&lang=js&"
export * from "./story-row.vue?vue&type=script&lang=js&"
import style0 from "./story-row.vue?vue&type=style&index=0&id=4c9553ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9553ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9553ee')) {
      api.createRecord('4c9553ee', component.options)
    } else {
      api.reload('4c9553ee', component.options)
    }
    module.hot.accept("./story-row.vue?vue&type=template&id=4c9553ee&scoped=true&", function () {
      api.rerender('4c9553ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/story-row.vue"
export default component.exports